export default __webpack_public_path__ + "static/media/gridImage7.f05759f0.jpg";